import React from 'react';
import { Link } from 'react-router-dom';
import QCodesQuiz from '../components/QCodesQuiz';
import qCodesQuizData from '../data/qcodes';

const QCodesPage = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
      <header className="mb-6 sm:mb-8">
        <div className="flex items-center mb-4">
          <Link
            to="/"
            className="text-blue-600 hover:text-blue-700 flex items-center space-x-2 text-sm sm:text-base mb-2"
          >
            <span>←</span>
            <span>Back to Home</span>
          </Link>
        </div>
        
        <div className="text-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            {qCodesQuizData.title}
          </h1>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            {qCodesQuizData.description}
          </p>
        </div>
      </header>

      <div className="max-w-4xl mx-auto">
        <QCodesQuiz quiz={qCodesQuizData} />
      </div>

      <div className="max-w-4xl mx-auto mt-8 text-center">
        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-3">
            About Q Codes
          </h3>
          <p className="text-gray-600 text-sm">
            Q codes are three-letter codes used in amateur radio communication to standardize 
            common questions and responses. They save time and provide clarity in radio communications, 
            especially in international contacts where language barriers may exist.
          </p>
        </div>
      </div>
    </div>
  );
};

export default QCodesPage;